import { Customer, CustomerVideoFeedback } from '@/shared/types/Admin';

import { BASE_URL } from '../constants';
import { get, patch } from '../requestMethods';
import {
  GetCSVRequestData,
  GetCustomersFeedbackRequestData,
  GetCustomersRequestData,
  UpdateCustomerRequestData,
} from './types';

const URL = `${BASE_URL}/api/admin`;
export const ADMIN_API = {
  searchCustomer: (email: string) => get<Customer[]>(`${BASE_URL}/api/admin/users?email=${email}`),
  searchCustomerFeedbacks: (email: string) =>
    get<CustomerVideoFeedback[]>(`${BASE_URL}/api/admin/feedback?email=${email}`),
  // Get, search and update customers
  getCustomers: ({ endDate, filterBy, limit = 20, startDate }: GetCustomersRequestData) =>
    get<Customer[]>(
      `${URL}/users?date_gt=${startDate}&date_lt=${endDate}${
        filterBy === 'all' ? '' : `&subscription_type=${filterBy}`
      }&limit=${limit}`,
    ),
  // Get CSV data on donwload CSV click
  getCustomersCSV: ({ email, endDate, startDate }: GetCSVRequestData) =>
    get<Blob>(`${URL}/users/csv?${email ? `&email=${email}` : `date_gt=${startDate}&date_lt=${endDate}`}`),
  getCustomersFeedbacksCSV: ({ email, endDate, startDate }: GetCSVRequestData) =>
    get<Blob>(`${URL}/feedback/csv?${email ? `&email=${email}` : `date_gt=${startDate}&date_lt=${endDate}`}`),
  // Get all feedbacks
  getFeedback: ({ endDate, limit = 20, startDate }: GetCustomersFeedbackRequestData) =>
    get<CustomerVideoFeedback[]>(`${URL}/feedback?date_gt=${startDate}&date_lt=${endDate}&limit=${limit}`),
  updateCustomer: ({ customerId, ...rest }: Partial<UpdateCustomerRequestData>) =>
    patch<Customer>(`${URL}/users/${customerId}`, { data: rest }),
};
